<ng-container *ngIf="(call.peerId | isAnonymous) || (call.peerId | isEmpty | async)">
   {{ 'common.calling.unknown_number' | translate }}
</ng-container>

<ng-container *ngIf="!(call.peerId | isAnonymous) && !(call.peerId | isEmpty | async)">
   <ng-container *ngIf="!(call.peerName | isEmpty | async)">
      {{ call.peerName }}
   </ng-container>
   <ng-container>
      <span [ngClass]="{ 'sam-add-brackets': !(call.peerName | isEmpty | async) }">{{ call.peerId }}</span>
   </ng-container>
</ng-container>
